import { render, staticRenderFns } from "./AkDetails.vue?vue&type=template&id=72178150&"
import script from "./AkDetails.vue?vue&type=script&lang=js&"
export * from "./AkDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports